import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';
import { StartupService } from './startup.service';
import { WoodLookImage } from '../models/wood-look-image.model';

@Injectable()
export class WoodLookImageService {

  constructor(private http: HttpClient, private startupService: StartupService) {
  }

  getWoodLookImage(): Promise<WoodLookImage[]> {
    return this.http.get<WoodLookImage>(`${environment.apiUrl}/woodLookImage/${this.startupService.websiteName}`)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error')).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/wood-look.service.ts